export default __webpack_public_path__ + "static/Make_PDFs_searchable-f529bfe796c158679ba4547fe29c2e2f.png";